import React from "react";
import PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";
import { useHistory, useLocation } from "react-router-dom";
import {
  getContentsByKey,
  getContentValueByKey,
  routeCountryPath
} from "../../../shared/utilities/common";
import CmsInlineEdit from "../../Cms/CmsInlineEdit";
import amplitudeAnalytics from "../../../shared/utilities/amplitude";

function Promotions({ contents }) {
  const history = useHistory();
  const location = useLocation();

  const trackPromotionsCta = (linkTitle, rowTitle) => {
    const element = [rowTitle, linkTitle].filter(Boolean).join(" — ") || "Promotions CTA";
    amplitudeAnalytics.trackCmsMappedPageClick({
      pathname: location.pathname,
      contentSection: "Bottom feature",
      contentElement: element,
    });
  };

  const getActionButton = (url, title, rowTitle) => {
    const buttonStyles = "flex items-center justify-center text-dark dark:text-white h-[54px] px-8 bg-transparent font-montserratMedium border-solid border border-dark dark:border-darkBorder rounded-[54px] cursor-pointer";
    
    if (/(http(s?)):\/\//i.test(url)) {
      return (
        <a
          className={buttonStyles}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          role="button"
          aria-label={title}
          onClick={() => trackPromotionsCta(title, rowTitle)}
        >
          {title}
        </a>
      );
    }

    const handleNavigation = () => {
      trackPromotionsCta(title, rowTitle);
      history.push(routeCountryPath(url));
    };

    return (
      <button
        type="button"
        className={buttonStyles}
        onClick={handleNavigation}
        aria-label={title}
      >
        {title}
      </button>
    );
  };

  const getRowsData = () => {
    return contents?.map((item, index) => {
      const even = index % 2;
      const title = getContentValueByKey(item.children, "title");
      const description = getContentValueByKey(item.children, "description");
      const image = getContentValueByKey(item.children, "image");
      const links = getContentsByKey(item.children, "links");
      return (
        <div className="md:grid grid-cols-2 md:gap-8 lg:gap-0 lg:max-w-screen-desktop lg:mx-auto">
          <div className={`${even ? "md:hidden block" : "block"}`}>
            <ReactMarkdown className="md:w-full">{image}</ReactMarkdown>
          </div>
          <div className="self-center md:mt-0 mt-8">
            <div className="flex flex-col gap-4 m-auto lg:w-3/5 lg:items-start items-center">
              <h2 className="text-dark dark:text-white font-black font-congenialBlack text-4xl leading-9 tracking-tighter">
                {title}
              </h2>

              <p className="text-dark dark:text-white font-montserratMedium font-normal leading-5 tracking-tighter">
                <ReactMarkdown>{description}</ReactMarkdown>
              </p>

              <div className=" flex flex-row lg:flex-col gap-4 ">
                {links.map(link => {
                  const linkTitle = getContentValueByKey(link.children, "title");
                  const linkUrl = getContentValueByKey(link.children, "url");
                  return getActionButton(linkUrl, linkTitle, title);
                })}
              </div>
            </div>
          </div>

          <div className={`${even ? "md:block hidden" : "hidden"}`}>
            <ReactMarkdown className="md:w-full">{image}</ReactMarkdown>
          </div>
        </div>
      );
    });
  };

  return (
    <CmsInlineEdit type="list" cmsNode={{children: contents}} showChilds>
      <div className="md:grid grid-flow-row flex flex-col gap-8 w-full lg:px-0 px-4 mt-9">
        {getRowsData()}
      </div>
    </CmsInlineEdit>
  );
}

Promotions.propTypes = {
  contents: PropTypes.shape({}).isRequired
};

export default Promotions;
